/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Response } from '@neo4j-ndl/react/ai';

const listsMarkdown = `
# Lists Examples

## Simple Unordered List

- Apple
- Banana
- Cherry
- Date
- Elderberry

## Simple Ordered List

1. First step
2. Second step
3. Third step
4. Fourth step
5. Fifth step

## Nested Unordered Lists

- Fruits
  - Apples
    - Granny Smith
    - Honeycrisp
    - Fuji
  - Oranges
    - Navel
    - Blood Orange
  - Berries
    - Strawberry
    - Blueberry
    - Raspberry
- Vegetables
  - Leafy Greens
    - Spinach
    - Kale
  - Root Vegetables
    - Carrot
    - Potato

## Nested Ordered Lists

1. Introduction
   1. Overview
   2. Purpose
   3. Scope
2. Main Content
   1. Chapter 1
      1. Section 1.1
      2. Section 1.2
      3. Section 1.3
   2. Chapter 2
      1. Section 2.1
      2. Section 2.2
3. Conclusion
   1. Summary
   2. Recommendations

## Mixed Lists

1. Install dependencies
   - Node.js
   - npm or yarn
   - Git
2. Clone repository
   - \`git clone <url>\`
   - \`cd project-name\`
3. Configure settings
   1. Copy \`.env.example\` to \`.env\`
   2. Update configuration values:
      - Database URL
      - API keys
      - Port number
4. Start development server
   - Run \`npm install\`
   - Run \`npm start\`

## Lists with Paragraphs

- **First Item**
  
  This is a detailed explanation of the first item. It can contain multiple sentences and provide context.

- **Second Item**
  
  The second item also has a detailed explanation. This helps provide more information to the reader.

- **Third Item**
  
  Each item can have as much detail as needed.

## Lists with Code

- JavaScript example:
  
  \`\`\`javascript
  const items = ['a', 'b', 'c'];
  items.forEach(item => console.log(item));
  \`\`\`

- Python example:
  
  \`\`\`python
  items = ['a', 'b', 'c']
  for item in items:
      print(item)
  \`\`\`

## Task Lists Representation

- [x] Complete feature A
- [x] Write tests
- [ ] Review code
- [ ] Deploy to production
- [ ] Monitor metrics

## Lists with Links

1. Official Resources
   - [Neo4j Documentation](https://neo4j.com/docs)
   - [Neo4j Community](https://community.neo4j.com)
   - [Neo4j GitHub](https://github.com/neo4j)
2. Tutorials
   - [Getting Started Guide](https://neo4j.com/start)
   - [Cypher Query Language](https://neo4j.com/cypher)
3. Tools
   - Neo4j Desktop
   - Neo4j Browser
   - Neo4j Bloom

## Lists with Inline Formatting

- **Bold item** with regular text
- *Italic item* with regular text
- \`Code item\` with regular text
- Regular text with **bold**, *italic*, and \`code\`
- Combination: **bold and *italic* text** together
`;

export const Component = () => {
  return (
    <div className="max-w-4xl">
      <Response>{listsMarkdown}</Response>
    </div>
  );
};

export default Component;
